import axios from "axios";

export default function ProfilePasswordService(formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/my-profile/password",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
